import React, { useContext, useState } from 'react';
import { Link } from "react-router-dom";
import routes from "../../../constants/Routes";
import AppointmentPopup from './AppointmentPopup';
import AppointmentConfirmPopup from './AppointmentConfirmPopup';
import { useLocation } from 'react-router-dom'

import myCalender from "../../../assets/img/sidebar/my-calender.svg";
import myReport from "../../../assets/img/sidebar/my-report.svg";
// import myStatistics from "../../../assets/img/sidebar/my-statistics.svg";
import myCards from "../../../assets/img/sidebar/my-cards.svg";
// import myDocuments from "../../../assets/img/sidebar/my-documents.svg";
// import myTelemedInvitation from "../../../assets/img/sidebar/my-telemed-invitation.svg";
// import myIntakeForm from "../../../assets/img/sidebar/my-intake-form.svg";
import myAssessment from "../../../assets/img/sidebar/my-assessment.svg";
import myExercises from "../../../assets/img/sidebar/my-exercises.svg";
// import myPainlog from "../../../assets/img/sidebar/my-painlog.svg";
// import myInsights from "../../../assets/img/sidebar/my-insights.svg";
// import crossBtn from "../../../assets/img/utilities/cross-btn.svg";

import AppContext from "../../../contexts/AppContext";
import GLOBAL from "../../../global";
import useD2C from "../../../hooks/useD2C";
import {isNSCSubdomain} from "../../../utils/Utils";
import { useTenantFeatures } from "../../../features/tenantFeatures/useTenantFeature";

import './TopSideMenu.scss';

const TopSideMenu = (props) => {
    // noinspection CheckTagEmptyBody
    const location = useLocation();
    const { IsD2CEnabled } = useD2C();
    const [show, setShow] = useState(false);
    let [submitStatus , setSubmitStatus] = useState(false);
    const { toggleShowTakeAssessmentModal, toggleShowLeftSideMenuInMobile, userInfo, showTopNavigationInMobile } = useContext(AppContext);
    const { CanPatientCreateAssessment, IsPatientReportAvailable, IsAthleteEnabled } = userInfo.Permissions;
    const { isAthleteEnabled, isSpinealignEnabled, isExamineticsEnabled } = useTenantFeatures();

    console.log('isSpinealignEnabled', isSpinealignEnabled)

    const handleShow = (e) => {
        e.preventDefault();
        setShow(true);
    };

    const pull_data = (data) => {
        setShow(data);
    };

    const pull_data_submitStatus = (submit) =>{
        setSubmitStatus(submit);
    };

    const submitCloseFunc = (submit) =>{
        setSubmitStatus(submit);
    };

    const closeSideMenu = (e) => {
        e.preventDefault();

        if(window.innerWidth <= 1024) {
            toggleShowLeftSideMenuInMobile();
        }
    }

    console.log(IsPatientReportAvailable, !IsAthleteEnabled)

    return (
        <>
            {
                submitStatus && <AppointmentConfirmPopup submitCloseFunc={submitCloseFunc} submitStatus={submitStatus}/>
            }
            {show === true && <AppointmentPopup func={pull_data} show={show} submitFunc={pull_data_submitStatus}/>}


            {/*<div className="kt-aside-menu kt-mt-0 kt-padding-l-15">*/}
            <div className={`top-side-menu__header ${showTopNavigationInMobile ? 'top-side-menu__header--mobile-visible' : ''}`}>
                {/*Will be hidden for desktop and will show at mobile to tab*/}
                {/*<div className="side-menu-mobile-header">*/}
                {/*    <div className={`${styles['d-flex']} ${styles['justify-content-between']}`}>*/}
                {/*        <div className="kt-header__brand-logo">*/}
                {/*            <img className="kt-header__brand-logo" src={GLOBAL.WHITE_LOGO_URL} height="50" alt="MMH Logo"/>*/}
                {/*        </div>*/}
                {/*        <img src={crossBtn} alt="cross_btn" onClick={closeSideMenu}/>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {
                    !isSpinealignEnabled &&
                        <div className={`top-side-menu__side-menu-wrapper top-side-menu__side-menu-wrapper--click-handler`} onClick={closeSideMenu}>

                        {(!isAthleteEnabled && !isExamineticsEnabled) && (
                            <Link to={isAthleteEnabled ? `${routes.myAssessments}/false` : routes.dashboard} className={`kt-menu__link kt-menu__toggle`}>
                                <div
                                    className={`kt-menu__item kt-menu__item--submenu header-menu-container ${location.pathname.includes(`${routes.dashboard}`) ? 'tab-menu-active-color' : ''}`}
                                    aria-haspopup="true">
                                    <i className="fa-solid fa-table-list kt-mr-15 kt-menu__link-text"></i>
                                    <span className="kt-menu__link-text">Dashboard</span>
                                </div>
                            </Link>
                        )}

                        {!isExamineticsEnabled && (
                            <Link to={`${routes.myAssessments}/${false}`} className={`kt-menu__link kt-menu__toggle`}>
                                <div
                                    className={`kt-menu__item kt-menu__item--submenu header-menu-container ${location.pathname.includes(`${routes.myAssessments}`) ? 'tab-menu-active-color' : ''}`}
                                    aria-haspopup="true">
                                    {/*<i className="fa-solid fa-table-list kt-mr-15 kt-menu__link-text"></i>*/}
                                    <i className="fa-solid fa-list kt-mr-15 kt-menu__link-text"></i>
                                    <span className={`kt-menu__link-text`}>My Assessments</span>
                                </div>
                            </Link>
                        )}
                        {/*)}*/}

                        {CanPatientCreateAssessment &&
                            <div className={`kt-menu__item kt-menu__item--submenu header-menu-container`} aria-haspopup="true" onClick={toggleShowTakeAssessmentModal}>
                                <div className={`kt-menu__link kt-menu__toggle`}>
                                    <img className="kt-mr-15" src={myExercises} alt="Take Assessments" />
                                    <span className="kt-menu__link-text">Take Assessments</span>
                                </div>
                            </div>
                        }

                        {(!IsAthleteEnabled && !isExamineticsEnabled) && (
                            <Link to={`${routes.myExercises}/${false}`} className={`kt-menu__link kt-menu__toggle`}>
                                <div className={`kt-menu__item kt-menu__item--submenu header-menu-container ${location.pathname.includes(`${routes.myExercises}`) ? 'tab-menu-active-color' : ''}`} aria-haspopup="true">
                                    <i className="fa-solid fa-person-walking kt-mr-15 kt-menu__link-text"></i>
                                    <span className="kt-menu__link-text">My Exercises</span>
                                </div>
                            </Link>
                        )}

                        {/*<div className={`kt-menu__item  kt-menu__item--submenu header-menu-container`} aria-haspopup="true">*/}
                        {/*    <Link to={routes.myIntake} className="kt-menu__link kt-menu__toggle">*/}
                        {/*        <img className="kt-mr-15" src={myIntakeForm} alt="My Intake" />*/}
                        {/*        <span className={` ${location.pathname.includes(`${routes.myIntake}`) && "color-primary font-weight-600"}`}>My Intake Form</span>*/}
                        {/*    </Link>*/}
                        {/*</div>*/}
                        {/*<div className={`kt-menu__item  kt-menu__item--submenu header-menu-container`} aria-haspopup="true">*/}
                        {/*    <Link to={routes.myPainlogs} className="kt-menu__link kt-menu__toggle">*/}
                        {/*        <img className="kt-mr-15" src={myPainlog} alt="My Painlogs" />*/}
                        {/*        <span className={` ${location.pathname.includes(`${routes.myPainlogs}`) && "color-primary font-weight-600"}`}>My Painlogs</span>*/}
                        {/*    </Link>*/}
                        {/*</div>*/}
                        {/*</div>*/}

                        {/* Working with my Physician */}
                        {/*<div className=" ">*/}
                        {/*<div className={`kt-menu__item  kt-menu__item--active header-menu-container`} aria-haspopup="true">*/}
                        {/*    <a href={"!#"} rel="noopener noreferrer" onClick={event => event.preventDefault()}*/}
                        {/*       className="kt-menu__link cursor-hand">*/}
                        {/*        <span className="color-primary font-size-lg font-primary font-medium">Working with my Physician</span>*/}
                        {/*    </a>*/}
                        {/*</div>*/}

                        {(!IsAthleteEnabled && (!isExamineticsEnabled || userInfo?.hasActiveTelemedicineInvitation)) && (
                            <Link to={routes.myCalendar} className={`kt-menu__link kt-menu__toggle`}>
                                <div className={`kt-menu__item kt-menu__item--submenu header-menu-container ${location.pathname.includes(`${routes.myCalendar}`) ? 'tab-menu-active-color' : ''}`} aria-haspopup="true">
                                    <i className="fa-solid fa-calendar-days kt-mr-15 kt-menu__link-text"></i>
                                    <span className="kt-menu__link-text">My Calendar</span>
                                </div>
                            </Link>
                        )}
                        {/*<div className={`kt-menu__item  kt-menu__item--submenu header-menu-container`} aria-haspopup="true">*/}
                        {/*    <Link to={routes.myDocuments} className="kt-menu__link kt-menu__toggle">*/}
                        {/*        <img className="kt-mr-15" src={myDocuments} alt="My Documents" />*/}
                        {/*        <span className={` ${location.pathname.includes(`${routes.myDocuments}`) && "color-primary font-weight-600"}`}>My Documents</span>*/}
                        {/*    </Link>*/}
                        {/*</div>*/}
                        {/*<div className={`kt-menu__item  kt-menu__item--submenu header-menu-container`} aria-haspopup="true">*/}
                        {/*    <Link to={routes.myTelemedicineInvitation} className="kt-menu__link kt-menu__toggle">*/}
                        {/*        <img className="kt-mr-15" src={myTelemedInvitation} alt="My Telemedicine Invitation" />*/}
                        {/*        <span className={` ${location.pathname.includes(`${routes.myTelemedicineInvitation}`) && "color-primary font-weight-600"}`}>My Telemed Invitations</span>*/}
                        {/*    </Link>*/}
                        {/*</div>*/}
                        {/*<div className={`kt-menu__item  kt-menu__item--submenu header-menu-container`} aria-haspopup="true">*/}
                        {/*    <div onClick={handleShow}  className="kt-menu__link kt-menu__toggle">*/}
                        {/*        <i className="-icon-color kt-menu__link-icon fa fa-handshake color-primary"></i>*/}
                        {/*        <span className=" kt-menu__link-text">Request an Appointment</span>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*</div>*/}

                        {/* My Statistics */}
                        {/*<div className=" ">*/}
                        {/*<div className={`kt-menu__item  kt-menu__item--active header-menu-container`} aria-haspopup="true">*/}
                        {/*    <a href={"!#"} rel="noopener noreferrer" onClick={event => event.preventDefault()}*/}
                        {/*       className="kt-menu__link cursor-hand">*/}
                        {/*        <span className="color-primary font-size-lg font-primary font-medium">My Statistics</span>*/}
                        {/*    </a>*/}
                        {/*</div>*/}

                        {(IsPatientReportAvailable && (!IsAthleteEnabled) && !isExamineticsEnabled)
                            ? (
                                <Link to={routes.myReports} className={`kt-menu__link kt-menu__toggle`}>
                                    <div
                                        className={`kt-menu__item kt-menu__item--submenu header-menu-container ${location.pathname.includes(`${routes.myReports}`) ? 'tab-menu-active-color' : ''}`}
                                        aria-haspopup="true">
                                        <i className="fa-solid fa-square-poll-horizontal kt-mr-15 kt-menu__link-text"></i>
                                        <span className="kt-menu__link-text">My Reports</span>
                                    </div>
                                </Link>
                            )
                            : ""
                        }

                        {(IsD2CEnabled && !isNSCSubdomain())
                            ? (
                                <Link to={routes.packages} className={`kt-menu__link kt-menu__toggle`}>
                                    <div className={`kt-menu__item kt-menu__item--submenu header-menu-container ${location.pathname.includes(`${routes.packages}`) ? 'tab-menu-active-color' : ''}`} aria-haspopup="true">
                                        <i class="fa-regular fa-calendar kt-mr-15"></i>
                                        <span className="kt-menu__link-text">Purchase Another Assessment</span>
                                    </div>
                                </Link>
                            ): ""
                        }

                        {/*<Link to={routes.myStatistics} className="kt-menu__link kt-menu__toggle">*/}
                        {/*    <div className={`kt-menu__item  kt-menu__item--submenu header-menu-container ${location.pathname.includes(`${routes.myStatistics}`) && "tab-menu-active-color"}`} aria-haspopup="true">*/}
                        {/*        <img className="kt-mr-15" src={myStatistics} alt="My Statistics" />*/}
                        {/*        <span>My Statistics</span>*/}
                        {/*    </div>*/}
                        {/*</Link>*/}
                        {/*<div className={`kt-menu__item  kt-menu__item--submenu header-menu-container ${location.pathname.includes(`${routes.myInsight}`) && "tab-menu-active-color"}`} aria-haspopup="true">*/}
                        {/*    <Link to={routes.myInsight} className="kt-menu__link kt-menu__toggle">*/}
                        {/*        <img className="kt-mr-15" src={myInsights} alt="My Insight" />*/}
                        {/*        <span>My Insights</span>*/}
                        {/*    </Link>*/}
                        {/*</div>*/}

                        {GLOBAL?.IS_SUBSCRIPTION_ENABLED &&
                            <Link to={routes.cards} className={`kt-menu__link kt-menu__toggle`}>
                                <div className={`kt-menu__item kt-menu__item--submenu header-menu-container ${location.pathname.includes(`${routes.cards}`) ? 'tab-menu-active-color' : ''}`} aria-haspopup="true">
                                    <img className="kt-mr-15" src={myCards} alt="Credit Cards" />
                                    <span className="kt-menu__link-text">Credit Cards</span>
                                </div>
                            </Link>
                        }
                        {/*</div>*/}
                    </div>
                }
            </div>
        </>
    );
};

export default TopSideMenu;
